var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableHousePricing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1 14 16 2 31 14",
    fill: "none",
    stroke: "#a805fb",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-cap": "butt",
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5 16 5 30 27 30 27 16",
    fill: "none",
    stroke: "#a805fb",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 24 14 19 17 22 22 17",
    fill: "none",
    stroke: "#a805fb",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-color": "color-2",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18 15 24 15 24 21 18 15",
    fill: "#a805fb",
    "data-cap": "butt",
    "data-color": "color-2",
    "data-stroke": "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableHousePricing);
export default __webpack_public_path__ + "static/media/Table-House-Pricing.ec18aa7ef906da5e.svg";
export { ForwardRef as ReactComponent };